import './waterfall-tooltip.component.scss';
import { DecompModelSparkLineComponent } from '../charts/decomp-model-spark-line.component';
import { WaterfallTooltipComponentProps } from './waterfall-tooltip.component';

const aspectRatio = 16 / 10;
export const WaterfallTooltipBodySingleComponent = ({
  data,
}: WaterfallTooltipComponentProps) => {
  return (
    <div className="waterfall-tooltip-body-single">
      {data && (
        <DecompModelSparkLineComponent
          chartData={{
            children: data.totals,
            value: data.value,
            id: data.id,
            label: data.label,
            color: data.color,
            max: data.max,
          }}
          aspectRatio={aspectRatio}
          displayAxis={true}
        />
      )}
    </div>
  );
};
